import React from 'react'
import './domain-segmentation-settings.scss'
import classnames from 'classnames'
import DomainSettingsTab, {
    IDomainSettingsTab,
    IDomainSettingsTabState,
} from '../abstract-domain-settings-tab/abstract-domain-settings-tab'
import { GeneralSettingsWell } from './general-settings-well'

interface IDomainSegmentationSettings extends IDomainSettingsTab {}

interface IState extends IDomainSettingsTabState {}

class DomainSegmentationSettings extends DomainSettingsTab<IDomainSegmentationSettings, IState> {
    public render() {
        return (
            <div className={classnames('domain-settings-tab', 'domain-segmentation-settings')}>
                <GeneralSettingsWell
                    loading={this.state.loading}
                    domain={this.state.domain!}
                    onDomainUpdated={this.handleDomainUpdated}
                />
            </div>
        )
    }
}

export default DomainSegmentationSettings
